import React from 'react'
import { useTranslation } from 'react-i18next'
import PageWrap from '../../components/PageWrap/PageWrap'
import { FilterContextProvider } from '../../context/FilterContext'
import { TABLE_TYPES } from '../../enums/enumTableTypes'
import TableContracts from '../../tables/TableContracts/TableContracts'

const NoveVitezovePage = () => {
  const { t } = useTranslation()

  return (
    <PageWrap
      title={t('title.vitezove', 'Vítězové veřejných zakázek')}
      subtitle={t('title.vitezove_text', 'Dnes zveřejnění vítězové veřejných zakázek.')}
    >
      <FilterContextProvider name={TABLE_TYPES.newWins}>
        <TableContracts showDodavatel />
      </FilterContextProvider>
    </PageWrap>
  )
}

export default NoveVitezovePage
